import { render, staticRenderFns } from "./jiaofeimingxi.vue?vue&type=template&id=f2546d7e&scoped=true"
import script from "./jiaofeimingxi.vue?vue&type=script&lang=js"
export * from "./jiaofeimingxi.vue?vue&type=script&lang=js"
import style0 from "./jiaofeimingxi.vue?vue&type=style&index=0&id=f2546d7e&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2546d7e",
  null
  
)

export default component.exports